export function useSetPageTitle(title) {
    const currentTitle = document.title
    if (!title || currentTitle === title) {
        return
    }
    document.title = title
}
